module.exports = __webpack_public_path__ + "static/media/2.fdc654c5.png";